// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".F4keL\\+JBTLjoPBK\\+x\\+RSMg\\=\\={height:56px;width:100%;display:flex;flex-direction:row}", "",{"version":3,"sources":["webpack://./src/pages/Couriers/components/CourierListTabMenu/CourierListTabMenu.module.scss"],"names":[],"mappings":"AAAA,+BACE,WAAA,CACA,UAAA,CACA,YAAA,CACA,kBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manageCouriersTabIndicator": "F4keL+JBTLjoPBK+x+RSMg=="
};
export default ___CSS_LOADER_EXPORT___;
